export default __webpack_public_path__ + "static/brcc-work-image-715d7dd554ab648f58ed2134aee9ed79.avif";